<template>
  <a-row :gutter="10">
    <a-col :md="12" :sm="24">
      <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px;">
          <a-button v-has="'customerList:add'" @click="handleAdd(1)" type="primary">添加客户</a-button>
          <a-button v-has="'customerList:addSub'" @click="handleAdd(2)" type="primary">添加下级</a-button>
          <a-button v-has="'customerList:export'" type="primary" icon="download" @click="handleExportXls('客户信息')">导出</a-button>
          <a-upload v-has="'customerList:import'" name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload>
        </a-row>
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              当前选择：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">取消选择</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" placeholder="请输入客户名称"/>
          <!-- 树-->
          <a-col :md="10" :sm="24" style="padding-left: 0px;padding-right: 0px; width: 100%">
            <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
             <span style="user-select: none">
               <a-tree id="company-tree"
                checkable
                multiple
                @select="onSelect"
                @check="onCheck"
                @rightClick="rightHandle"
                :selectedKeys="selectedKeys"
                :checkedKeys="checkedKeys"
                :treeData="companyTree"
                :checkStrictly="checkStrictly"
                :expandedKeys="iExpandedKeys"
                :autoExpandParent="autoExpandParent"
                @expand="onExpand"/>
             </span>
              <!--新增右键点击事件,和增加添加和删除功能-->
              <a-menu slot="overlay">
                <a-menu-item v-has="'customerList:addSub'" @click="handleAdd(3)" key="1">添加下级</a-menu-item>
                <a-menu-item v-has="'customerList:del'" @click="handleDelete" key="2">删除</a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
        </div>
      </a-card>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="3" @click="checkALL">全部勾选</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">取消全选</a-menu-item>
            <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
            <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
          </a-menu>
          <a-button>
            树操作 <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
    </a-col>

    <a-col :md="12" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="基本信息" key="1">
          <a-card :bordered="false" v-if="selectedKeys.length>0">
            <a-form :form="form">
              <a-row>
                <a-col :span="24">
                  <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['name',validatorRules.name]" placeholder="请输入客户名称" ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="客户编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['code',validatorRules.code]" placeholder="请输入客户编码"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="上级客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-search-select-tag type="list" dict="biz_customer,name,id" v-decorator="['parentId', {}]" :async="true" placeholder="请至少输入两个汉字查询">
                    </j-search-select-tag>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="客户状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="[ 'status', validatorRules.status]" placeholder="请选择状态" :getPopupContainer= "(target) => target.parentNode" >
                      <a-select-option :value="1">正常</a-select-option>
                      <a-select-option :value="2">冻结</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="客户分组2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['groups', validatorRules.groups]" placeholder="请选择客户分组">
                      <a-select-option :value="1">安能一组</a-select-option>
                      <a-select-option :value="2">安能二组</a-select-option>
                      <a-select-option :value="3">安能公共</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="客户性质" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-dict-select-tag dictCode="bms_customer_type" :triggerChange="true" v-decorator="[ 'customerType', validatorRules.customerType]" placeholder="请选择客户性质" >
                    </j-dict-select-tag>
                  </a-form-item>
                </a-col>
                <!--先隐藏，暂时不用，未处理文件上传漏洞问题-->
                <!--<a-col :span="24">
                  <a-form-item label="客户logo" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <j-image-upload v-decorator="['logo']" disabled></j-image-upload>
                  </a-form-item>
                </a-col>-->
                <a-col :span="24">
                  <a-form-item label="注册地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['registerAddress', validatorRules.registerAddress]" placeholder="请输入客户注册地址"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['contact', validatorRules.contact]" placeholder="请输入联系人"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['phone', validatorRules.phone]" placeholder="请输入电话"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['mail', validatorRules.mail]" placeholder="请输入邮箱"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="内外部客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['insideOutside']" placeholder="请选择内外部客户" :getPopupContainer="(target) => target.parentNode">
                      <a-select-option value="1">内部客户</a-select-option>
                      <a-select-option value="2">外部客户</a-select-option>
                      <a-select-option value="3">个人直拓</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <div class="anty-form-btn">
              <a-button v-has="'customerList:save'" @click="submitCurrForm" type="primary" htmlType="button" icon="form">保存</a-button>
            </div>
          </a-card>
          <a-card v-else >
            <a-empty>
              <span slot="description"> 请先选择一个客户! </span>
            </a-empty>
          </a-card>
        </a-tab-pane>
      </a-tabs>

    </a-col>
    <customer-modal ref="CustomerModal" @ok="loadTree"></customer-modal>
  </a-row>
</template>
<script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import CustomerModal from './modules/CustomerModal'
  import pick from 'lodash.pick'
  import {deleteAction, httpAction, getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {toTreeByRecursion} from '@/utils/tree'

  // 表头
  const columns =  [
    {
      title: '#',
      dataIndex: '',
      key:'rowIndex',
      width:60,
      align:"center",
      customRender:function (t,r,index) {
        return parseInt(index)+1;
      }
    },
    {
      title:'客户名称',
      align:"center",
      dataIndex: 'name'
    },
    {
      title:'客户编码',
      align:"center",
      dataIndex: 'code'
    },
    {
      title:'客户状态',
      align:"center",
      dataIndex: 'status_dictText'
    },
    /*{
      title:'客户logo',
      align:"center",
      dataIndex: 'logo',
      scopedSlots: {customRender: 'imgSlot'}
    },*/
    {
      title:'电话',
      align:"center",
      dataIndex: 'phone'
    },
    {
      title:'邮箱',
      align:"center",
      dataIndex: 'mail'
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'action',
      scopedSlots: {customRender: 'action'}
    }
  ]
  export default {
    name: 'CustomerList',
    mixins: [JeecgListMixin],
    components: {
      JImageUpload,
      CustomerModal,
      JDictSelectTag,
      JSearchSelectTag,
    },
    data() {
      return {
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        disable: true,
        treeData: [],
        visible: false,
        companyTree: [],
        rightClickSelectedKey: '',
        rightClickSelectedCode: '',
        hiding: true,
        model: {},
        dropTrigger: '',
        depart: {},
        columns: columns,
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {},

        allTreeKeys:[],
        checkStrictly: true,

        form: this.$form.createForm(this),
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        graphDatasource: {
          nodes: [],
          edges: []
        },
        validatorRules: {
          name:{
            rules:[
              {required: true, message: '请输入客户名称'},
              {max: 50, message:'客户名字不能超过50个字符'}
            ]
          },
          code:{
            rules:[
              /*{required: true, message: '请输入客户编码'},*/
              {max: 20, message:'客户编码不能超过20个字符'}
            ]
          },
          customerType:{
            rules:[]
          },
          status:{
            rules:[
              {required: true, message: '请选择客户状态'}
            ]
          },
          groups:{
            rules:[
              {required: false, message: '请选择客户组别3'}
            ]
          },
          registerAddress:{
            rules:[
              {max: 255, message:'客户注册地址不能超过255个字符'}
            ]
          },
          contact:{
            rules:[
              {max: 30, message:'联系人名称长度不能超过30个字符'}
            ]
          },
          phone:{
            rules:[
              {max: 13, message:'请输入正确的电话号码'}
            ]
          },
          mail:{
            rules:[
              {type: 'email', message:'请输入正确的邮箱地址'},
              {max: 30, message: '邮箱长度不能超过30个字符'}
            ]
          },
          insuredName:{
            rules:[
              {type: 'insuredName', message:'请输入正确的被保人别称'},
            ]
          },
          /*companyType:{
            rules:[
              {required: true, message: '请选择客户类型'}
            ]
          }*/
        },
        url: {
          getAll: "/biz/customer/getAllCompany",
          searchByKeywords:"/biz/customer/searchByKeywords",
          edit: "/biz/customer/edit",
          delete: "/biz/customer/delete",
          deleteBatch: "/biz/customer/deleteBatch",
          exportXlsUrl: "/biz/customer/exportXls",
          importExcelUrl: "/biz/customer/importExcel",
        },
        orgCategoryDisabled:false,
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      loadData() {
        this.refresh();
      },
      loadTree() {
        var that = this
        that.treeData = []
        that.companyTree = []

        getAction(this.url.getAll).then((res) =>{
          if(res.success){
            debugger
            //转为树形结构数据
            let resultTreeData = toTreeByRecursion(res.result,'id','parentId', null,'children',{enable:true});
            this.allTreeKeys = [];
            for (let i = 0; i < resultTreeData.length; i++) {
              let temp = resultTreeData[i]
              that.treeData.push(temp)
              that.companyTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
            }
            this.loading = false
          }
        })
      },

      onSearch(value){
        let that = this
        that.treeData = []
        that.companyTree = []
        that.allTreeKeys = [];

        if (value) {
          getAction(this.url.searchByKeywords, {keyword:value}).then((res) => {
            if (res.success) {
              //查询结果不转树形结构数据，用临时字段做平铺，保留原始 parentId 供表单展示
              for (let i = 0; i < res.result.length; i++) {
                res.result[i]._treeParentId = null
              }

              let resultTreeData = toTreeByRecursion(res.result,'id','_treeParentId', null,'children',{enable:true});
              for (let i = 0; i < resultTreeData.length; i++) {
                let temp = resultTreeData[i]
                that.treeData.push(temp)
                that.companyTree.push(temp)
                //that.setThisExpandedKeys(temp) 无展开折叠key
                that.getAllKeys(temp);
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }
      },

      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      // 右键操作方法
      rightHandle(node) {
        this.dropTrigger = 'contextmenu'
        this.rightClickSelectedKey = node.node.eventKey
        this.rightClickSelectedCode = node.node.dataRef.code
      },
      onExpand(expandedKeys) {
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      // 右键点击下拉框改变事件
      dropStatus(visible) {
        if (visible == false) {
          this.dropTrigger = ''
        }
      },

      onCheck(checkedKeys, info) {
        this.hiding = false
        if(this.checkStrictly){
          this.checkedKeys = checkedKeys.checked;
        }else{
          this.checkedKeys = checkedKeys
        }
      },
      onSelect(selectedKeys, e) {
        this.hiding = false
        let record = e.node.dataRef
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        this.selectedKeys = [record.key]
        this.model.parentId = record.parentId
        this.setValuesToForm(record)
      },
      // 触发onSelect事件时,为部门树右侧的form表单赋值
      setValuesToForm(record) {
        if(record.orgCategory == '1'){
          this.orgCategoryDisabled = true;
        }else{
          this.orgCategoryDisabled = false;
        }
        this.$nextTick(() => {
          this.form.getFieldDecorator('fax', {initialValue: ''})
          this.form.setFieldsValue(pick(record, 'name', 'code', 'status', 'groups', 'logo', 'phone', 'mail','parentId',
            'customerType','contact','registerAddress','insuredName','insideOutside'))
        })
      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.form.resetFields()
        this.selectedKeys = []
      },
      handleNodeTypeChange(val) {
        this.currSelected.nodeType = val
      },
      notifyTriggerTypeChange(value) {
        this.currSelected.notifyTriggerType = value
      },
      receiptTriggerTypeChange(value) {
        this.currSelected.receiptTriggerType = value
      },
      submitCurrForm() {
        this.form.validateFields((err, values) => {
          if (!err) {
            if (!this.currSelected.id) {
              this.$message.warning('请点击选择要修改客户!')
              return
            }

            let formData = Object.assign(this.currSelected, values)
            httpAction(this.url.edit, formData, 'put').then((res) => {
              if (res.success) {
                this.$message.success('保存成功!')
                this.loadTree()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },

      handleAdd(num) {
        if (num == 1) {
          this.$refs.CustomerModal.add(null)
          this.$refs.CustomerModal.title = '新增'
        } else if (num == 2) {
          let key = this.currSelected.key
          if (!key) {
            this.$message.warning('请先点击选中上级客户！')
            return false
          }
          this.$refs.CustomerModal.add(key)
          this.$refs.CustomerModal.title = '新增'
        } else {
          this.$refs.CustomerModal.add(this.rightClickSelectedKey)
          this.$refs.CustomerModal.title = '新增'
        }
      },
      handleDelete() {
        var that = this

        this.$confirm({
          title: '确认删除',
          content: '确定要删除当前客户吗?',
          onOk: function () {
            deleteAction(that.url.delete, {id: that.rightClickSelectedKey}).then((res) => {
              if (res.success) {
                //删除成功后，去除已选中的数据
                that.checkedKeys.splice(that.checkedKeys.findIndex(key => key === that.rightClickSelectedKey), 1);
                that.$message.success('删除成功!')
                that.loadTree()
                //删除后同步清空右侧基本信息内容
                let code = that.form.getFieldValue("code");
                if(code && code === that.rightClickSelectedCode){
                  that.onClearSelected()
                }
              } else {
                that.$message.warning('删除失败!')
              }
            })
          }
        })
      },

      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      checkALL () {
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      getAllKeys(node) {
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
    },
    created() {
    },
    // beforeMount(){
    //   let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   this.treeHeight = "height:" + clientHeight - 230 + "px;";
    // },
  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }

  #company-tree{
    width: 100%;
    height: 566px; /*和右边高度一致*/
    overflow-y: scroll;
  }
</style>